// There are many more but this is all we use.
enum KeyboardEventKey {
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  ArrowUp = "ArrowUp",
  Backspace = "Backspace",
  Enter = "Enter",
}

export default KeyboardEventKey;
